/* eslint-disable max-len */
import { Formik } from "formik";
import classNames from "classnames";
import globalStyle from "../../../../../assets/scss/global.module.scss";
import styles from "./RequestPayoutPage.module.scss";
import { dashboardSelector } from "@podcasts/store/dashboard";
import * as yup from "yup";
import { Link, useParams, useNavigate } from "react-router-dom";
import { useDispatch, useSelector } from "react-redux";
import {
  Button,
  InputSelect,
  CheckBox,
  RadioButton,
} from "../../../../../components";
import NumberRating from "../../../../../components/NumberRating/NumberRating";
import React, { useState, useEffect, forwardRef } from "react";
import { toast } from "react-toastify";
import {
  getPodcast,
  getRecentlyViewed,
  getRequestPayOut,
  clearSelectedPodcast,
} from "@podcasts/store/dashboard";
import { TextArea } from "../../../../../components";
import { requestPayout } from "@podcasts/store/dashboard";
import { userSelector } from "@podcasts/store/user";
import DatePicker from "react-datepicker";
import { useRequestPayment } from "@podcasts/hooks";
import { usePrevious } from "../../../../../hooks/usePrevious";
import { showToastMessage } from "../../../../../utils/common";
import moment from "moment";
import { Tooltip } from "react-tooltip";

interface InputProps {
  label?: string;
  placeholder?: string;
  type?: string;
  value?: any;
  onClick?: any;
  onChange?: any;
  onBlur?: any;
  error?: string | null;
  name?: string;
  disabled?: boolean;
}
const CustomInput = forwardRef(
  (
    {
      value,
      onClick,
      error,
      placeholder,
      disabled,
      type,
      name,
      label,
      ...props
    }: InputProps,
    ref: any
  ) => {
    const id = name || label || Math.random().toString(36).slice(2);
    const classNamesForInput = classNames(
      globalStyle["inputContainer"],
      error ? globalStyle["inputError"] : ""
    );
    return (
      <div className={classNamesForInput}>
        <input
          id={id}
          name={name}
          type={type}
          placeholder={placeholder}
          value={value || ""}
          onClick={onClick}
          ref={ref}
          disabled={disabled}
          {...props}
        />
        {error && <span className={globalStyle["errorMessage"]}>{error}</span>}
      </div>
    );
  }
);

export function RequestPayoutPage() {
  const { id } = useParams();
  const dispatch = useDispatch<any>();
  const {
    podcast,
    recently_viewed: { data = [] },
    loading,
    total_payout_request,
  } = useSelector(dashboardSelector) as any;
  const { user } = useSelector(userSelector) as any;

  const { canRequestPayment } = useRequestPayment();

  const [success, setSuccess] = useState(false);
  const [different, setDifferent] = useState(false);
  const [showExternalLink, setShowExternalLink] = useState(false);

  const navigate = useNavigate();

  const { payoutRequestSuccess, payoutRequestError, requestedMoreThanAllowed } =
    useSelector(dashboardSelector) as any;
  const prevPayoutRequestSuccess = usePrevious(payoutRequestSuccess);
  const prevPayoutRequestError = usePrevious(payoutRequestError);

  useEffect(() => {
    return () => {
      dispatch(clearSelectedPodcast());
    };
  }, []);

  useEffect(() => {
    if (user && user.role !== "Student") {
      navigate("/podcasts/featured", { replace: true });
    }
  }, [user]);

  useEffect(() => {
    if (
      payoutRequestSuccess &&
      payoutRequestSuccess !== prevPayoutRequestSuccess
    ) {
      navigate("/podcasts/featured", { replace: true });
      showToastMessage(payoutRequestSuccess, "success", "BOTTOM_CENTER", true);
    }
  }, [payoutRequestSuccess]);

  useEffect(() => {
    if (payoutRequestError && payoutRequestError !== prevPayoutRequestError) {
      // showToastMessage(payoutRequestError, "error");
      toast.error(
        "We’ve noticed that you’ve made 4 payment requests in the past 4 weeks. Please share your reason for this additional request in the form.",
        {
          position: "top-right",
          className: "foo-bar",
          theme: "colored",
          icon: false,
          autoClose: 30000,
          toastId: styles.requestedMoreThanAllowed,
        }
      );
    }
    // if (payoutRequestError === "Unauthenticated.") {
    //   dispatch(logOut());
    //   navigate("/login");
    // }
  }, [payoutRequestError]);

  useEffect(() => {
    // @ts-ignore
    dispatch(getPodcast(id));
    dispatch(getRecentlyViewed());
    // @ts-ignore
    dispatch(getRequestPayOut(id));
  }, []);

  useEffect(() => {
    if (id === "request") {
      setDifferent(true);
    }
  }, []);

  const schema = () =>
    yup.object().shape({
      date_learned: yup.string().required(),
      review: yup.string().required(),
      rating: yup.number().required(),
      podcast_id: yup.number().nullable(),
      is_public: yup.boolean().required(),
      external_podcast_title: showExternalLink
        ? yup.string().required()
        : yup.string().nullable(),
      external_podcast_url: showExternalLink
        ? yup.string().required()
        : yup.string().nullable(),
      social_event: yup.boolean().nullable().default(null),
      social_event_description: yup
        .string()
        .nullable()
        .when("social_event", ([social_event], schema) => {
          return social_event ? schema.required() : schema.nullable();
        }),
      request_reason: requestedMoreThanAllowed
        ? yup.string().required()
        : yup.string().nullable(),
    });

  const ReactDatePicker = DatePicker as any;

  // const toggleExternalPodcast = () => {
  //   setShowExternalLink(!showExternalLink);
  //   setDifferent(false);
  // }

  return (
    <>
      <div
        className={`${styles["request-close"]} d-flex align-items-center justify-content-end`}
      >
        <button
          className="normalize-btn"
          onClick={() =>
            !success ? navigate(-1) : navigate("/profile/payments")
          }
        >
          <i className="icon-close"></i>
        </button>
      </div>
      <div className={`${styles["request-body"]}`}>
        <h2>Request a payment</h2>
        {podcast && !different && !showExternalLink ? (
          <p>{podcast?.title}</p>
        ) : null}
        {!loading ? (
          <section>
            {" "}
            {!canRequestPayment || podcast?.is_payout_request_sent ? (
              <div>You already requested a payment for this podcast</div>
            ) : (
              <section>
                <Formik
                  enableReinitialize
                  initialValues={{
                    date_learned: null,
                    review: "",
                    rating: 1,
                    podcast_id: !different ? podcast?.id : null,
                    is_public: false,
                    reviewed: true,
                    external_podcast_title: null,
                    external_podcast_url: null,
                    request_reason: null,
                    social_event: null,
                    social_event_description: null,
                  }}
                  validationSchema={schema}
                  onSubmit={(values, { setSubmitting }) => {
                    //@ts-ignore
                    dispatch(requestPayout(values));
                    setSuccess(true);
                  }}
                >
                  {({
                    values,
                    errors,
                    touched,
                    handleChange,
                    handleBlur,
                    handleSubmit,
                    setFieldValue,
                  }) => (
                    <div className={`${styles["form"]}`}>
                      {!different && !showExternalLink ? (
                        <Link
                          to={"#"}
                          className={`${styles["choose-different"]}`}
                          onClick={() => {
                            setDifferent(true);
                            setShowExternalLink(false);
                          }}
                        >
                          Choose a different podcast
                        </Link>
                      ) : null}
                      <div className={`${styles["request-payout"]}`}>
                        {different ? (
                          <InputSelect
                            options={data.map((p: any) => ({
                              value: p.slug,
                              label: p.title,
                            }))}
                            label="Which podcast are you requesting payment for?"
                            placeholder="Your 10 most recently viewed"
                            name="gender"
                            onChange={({ value }: any) => {
                              //@ts-ignore
                              dispatch(getPodcast(value));
                              setDifferent(false);
                            }}
                            onBlur={handleBlur}
                            value={values.podcast_id}
                            error={
                              errors.podcast_id && touched.podcast_id
                                ? "Please choose a podcast"
                                : null
                            }
                          />
                        ) : null}
                      </div>
                      {/* <div>
                        {user?.approved_for_external_podcasts ? (
                          <div className={`${styles["external-podcast"]}`}>
                            <CheckBox
                              name="approved_for_external_podcasts"
                              label="External Podcast"
                              value={showExternalLink}
                              onChange={toggleExternalPodcast}
                            />
                            {
                              showExternalLink ? (
                                <>
                                  <Input
                                    placeholder="Please enter the title *"
                                    name="external_podcast_title"
                                    onChange={handleChange}
                                    onBlur={handleBlur}
                                    value={values.external_podcast_title}
                                    error={
                                      errors.external_podcast_title && touched.external_podcast_title
                                        ? "Required"
                                        : null
                                    }
                                  />
                                  <Input
                                    placeholder="Please enter the url *"
                                    name="external_podcast_url"
                                    onChange={handleChange}
                                    onBlur={handleBlur}
                                    value={values.external_podcast_url}
                                    error={
                                      errors.external_podcast_url && touched.external_podcast_url
                                        ? "Required"
                                        : null
                                    }
                                  />
                                </> 
                              ) : null
                            }
                          </div>
                        ) : null}

                      </div> */}
                      <div className={`${styles["podcast-review-date"]}`}>
                        <p>
                          When did you review this podcast with your mentor?*
                        </p>
                        <ReactDatePicker
                          placeholderText="mm/dd/yyyy"
                          // eslint-disable-next-line max-len
                          className={
                            !errors.date_learned
                              ? `${styles["calendar"]} ${globalStyle["inputContainer"]}`
                              : `${styles["calendar"]} ${styles["calendar--error"]}`
                          }
                          name="date_learned"
                          selected={values.date_learned}
                          onChange={(date: Date) => {
                            const adjustedDate = moment(date)
                              .subtract(date.getTimezoneOffset(), "minutes")
                              .toDate();
                            setFieldValue("date_learned", adjustedDate);
                          }}
                          customInput={<CustomInput />}
                          dateFormat="MM/dd/yyyy"
                          onBlur={handleBlur}
                          minDate={moment().subtract(6, "month").toDate()}
                          maxDate={moment().toDate()}
                        />
                        <p className={`${styles["datepicker-error"]}`}>
                          {errors.date_learned && "Required"}
                        </p>
                        {/* <p>Your mentor will be notified of your payment request.</p> */}
                      </div>
                      <div className={`${styles["podcast-rating"]}`}>
                        <p>What did you think of this podcast?*</p>
                        <NumberRating
                          titleStart="Didn’t love it"
                          onChange={(v: number) => {
                            setFieldValue("rating", v);
                          }}
                          titleEnd="Loved it"
                          name="rating-numbers"
                          value={values.rating}
                        />
                      </div>
                      <div className={`${styles["comments"]}`}>
                        <TextArea
                          rows={7}
                          placeholder="Write any comments you have..."
                          name="review"
                          onChange={handleChange}
                          onBlur={handleBlur}
                          value={values.review}
                          error={
                            errors.review && touched.review ? "Required" : null
                          }
                        />
                      </div>
                      <div className={`${styles["review-admin"]}`}>
                        <CheckBox
                          name="is_public"
                          label="Display my comment on the website. This will be reviewed by a Podcast Admin."
                          value={values.is_public}
                          onChange={handleChange}
                        />
                      </div>
                      {total_payout_request > 0 &&
                        total_payout_request % 5 === 0 && (
                          <div className={`${styles["review-admin"]} row`}>
                            <p>
                              Did you attend an in-person Jewish event/learning
                              session in the last 4 weeks?*
                            </p>
                            <div className="col-3 mt-0">
                              <RadioButton
                                name="social_event"
                                value={true}
                                label="Yes"
                                checked={values.social_event === true}
                                onChange={(value: any) => {
                                  setFieldValue("social_event", true);
                                }}
                              />
                            </div>
                            <div className="col-3 mt-0">
                              <RadioButton
                                name="social_event"
                                value={false}
                                label="No"
                                checked={values.social_event === false}
                                onChange={(value: any) => {
                                  setFieldValue("social_event", false);
                                }}
                              />
                            </div>
                            {values.social_event !== null && (
                              <div className={`${styles["comments"]}`}>
                                <TextArea
                                  rows={7}
                                  name="social_event_description"
                                  onChange={handleChange}
                                  onBlur={handleBlur}
                                  value={values.social_event_description}
                                  error={
                                    errors.review && touched.review
                                      ? "Required"
                                      : null
                                  }
                                  // eslint-disable-next-line max-len
                                  placeholder={`${
                                    values.social_event
                                      ? "Please elaborate and share your thoughts on the event."
                                      : "Please explain/request an excuse."
                                  }`}
                                />
                              </div>
                            )}
                          </div>
                        )}
                      {/* <div className={`${styles["review-admin"]}`}>
                          <CheckBox
                            name="reviewed"
                            value={values.reviewed}
                            onChange={handleChange}
                            error={
                              errors.reviewed && touched.reviewed
                                ? "Required"
                                : null
                            }
                            label='<p style="margin: 0;text-align: left;line-height:20px;"><span>I reviewed this class 
                            with my mentor *<span/></br><span style="opacity: .5;">You must review the class with 
                            your podcast mentor in order to earn $15</span></p>'
                          />
                        </div> */}

                      {requestedMoreThanAllowed ? (
                        <div className={`${styles["request-reason"]}`}>
                          <p>
                            Please indicate your reason for requesting another
                            payment.*
                            <span
                              className={`${styles["icon"]}`}
                              data-tooltip-id="reason-tooltip"
                            >
                              <svg
                                xmlns="http://www.w3.org/2000/svg"
                                width="16"
                                height="16"
                                viewBox="0 0 64 64"
                                fill="none"
                              >
                                <path
                                  d="M32 47.8649C32.621 47.8649 33.1401 47.6551 33.5573 47.2356C33.9769 46.816 34.1867 46.2957 34.1867 45.6747C34.1867 45.056 33.9769 44.5369 33.5573 44.1173C33.1401 43.6978 32.621 43.488 32 43.488C31.379 43.488 30.8599 43.6978 30.4427 44.1173C30.0231 44.5369 29.8133 45.056 29.8133 45.6747C29.8133 46.2957 30.0231 46.816 30.4427 47.2356C30.8599 47.6551 31.379 47.8649 32 47.8649ZM30.2222 36.1031H33.7778V14.7698H30.2222V36.1031ZM32.0107 64C27.5876 64 23.4276 63.1609 19.5307 61.4827C15.6361 59.8021 12.2477 57.5218 9.36533 54.6418C6.48296 51.7641 4.20148 48.3793 2.52089 44.4871C0.840297 40.595 0 36.4361 0 32.0107C0 27.5876 0.839111 23.4276 2.51733 19.5307C4.19793 15.6361 6.47822 12.2477 9.35822 9.36533C12.2359 6.48296 15.6207 4.20148 19.5129 2.52089C23.405 0.840297 27.5639 0 31.9893 0C36.4124 0 40.5724 0.839111 44.4693 2.51733C48.3638 4.19793 51.7523 6.47822 54.6347 9.35822C57.517 12.2359 59.7985 15.6207 61.4791 19.5129C63.1597 23.405 64 27.5639 64 31.9893C64 36.4124 63.1609 40.5724 61.4827 44.4693C59.8021 48.3638 57.5218 51.7523 54.6418 54.6347C51.7641 57.517 48.3793 59.7985 44.4871 61.4791C40.595 63.1597 36.4361 64 32.0107 64ZM32 60.4444C39.9407 60.4444 46.6667 57.6889 52.1778 52.1778C57.6889 46.6667 60.4444 39.9407 60.4444 32C60.4444 24.0593 57.6889 17.3333 52.1778 11.8222C46.6667 6.31111 39.9407 3.55556 32 3.55556C24.0593 3.55556 17.3333 6.31111 11.8222 11.8222C6.31111 17.3333 3.55556 24.0593 3.55556 32C3.55556 39.9407 6.31111 46.6667 11.8222 52.1778C17.3333 57.6889 24.0593 60.4444 32 60.4444Z"
                                  fill="black"
                                />
                              </svg>
                            </span>
                          </p>
                          <Tooltip
                            id="reason-tooltip"
                            className={`${styles["tooltip-wrapper"]}`}
                            opacity={1}
                            classNameArrow={`${styles["arrow"]}`}
                            place="top-start"
                          >
                            <div className={`${styles["tooltip"]}`}>
                              We’ve noticed that you’ve made 4 payment requests
                              in the past 4 weeks. Please share your reason for
                              this additional request.
                            </div>
                          </Tooltip>
                          <TextArea
                            rows={6}
                            placeholder="Enter your reason here"
                            name="request_reason"
                            onChange={handleChange}
                            onBlur={handleBlur}
                            value={values.request_reason}
                            error={
                              errors.request_reason && touched.request_reason
                                ? "Required"
                                : null
                            }
                          />
                        </div>
                      ) : null}

                      <div className={`${styles["submit-button"]}`}>
                        <Button
                          name="Submit"
                          onClick={() => {
                            if (values.external_podcast_title) {
                              setFieldValue("podcast_id", null);
                            }
                            handleSubmit();
                          }}
                        />
                      </div>
                    </div>
                  )}
                </Formik>
              </section>
            )}{" "}
          </section>
        ) : null}
      </div>
    </>
  );
}

export default RequestPayoutPage;
